import styled, { css } from "styled-components";
import { CategorySelectorContainer, vizGridZIndices } from "../../viz/VizGrid";
import { gridSmallMediaSize } from "../../countryProfiles/Grid";

export const Divider = styled.div`
  height: 1rem;
  width: 1px;
  background-color: rgb(179, 179, 179);
  margin: 0 0.15rem;

  @media (max-width: 1100px) {
    height: 0.9rem;
    margin: 0 0.12rem;
  }

  @media (max-width: 1000px) {
    height: 0.8rem;
    margin: 0 0.1rem;
  }

  @media (max-width: 600px) {
    height: 0.7rem;
    margin: 0 0.08rem;
  }
`;

export const categoryIconsContainerStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const SelectorContainer = styled(CategorySelectorContainer)`
  ${categoryIconsContainerStyle}
  z-index: ${vizGridZIndices.categorySelector};
  flex-wrap: wrap;
  gap: 0.15rem;
  padding: 0 0.25rem;
  max-width: 100%;
  justify-content: flex-start;
  align-items: center;
  min-height: 1.8rem;

  @media (max-width: 1200px) {
    gap: 0.12rem;
    padding: 0 0.2rem;
    min-height: 1.6rem;
  }

  @media (max-width: 1000px) {
    gap: 0.1rem;
    padding: 0 0.15rem;
  }

  @media (max-width: 600px) {
    gap: 0.08rem;
    padding: 0 0.1rem;
    min-height: 1.4rem;
  }
`;

export const ProductSectorLabel = styled.legend`
  color: #666;
  text-align: right;
  font-size: 0.65rem;
  line-height: 1.2;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  width: auto;
  margin-right: 0.5rem;
  white-space: nowrap;

  @media (max-width: 1200px) {
    font-size: 0.6rem;
    margin-right: 0.35rem;
  }

  @media (max-width: 1000px) {
    font-size: 0.55rem;
    margin-right: 0.25rem;
  }

  @media (max-width: 600px) {
    font-size: 0.5rem;
    margin-right: 0.2rem;
  }
`;
